import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Home from "./pages/Home";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import Courses from "./pages/Courses";
import Navbar from "../../frontend/src/components/Navbar";
import Sidebar from "../../frontend/src/components/Sidebar";
import Footer from "../../frontend/src/components/Footer";
import AdminResetPassword from "./pages/AdminResetPassword"; // adjust the path
import ScheduleGrid from './pages/ScheduleGrid'; // 
import AdminGenerateSchedule from "./pages/AdminGenerateSchedule";
import ScheduleManager from "./pages/ScheduleManager";
import RequireLeagueAdmin from "./components/RequireLeagueAdmin";
import HandicapGenerator from "./pages/HandicapGenerator";
import { AuthProvider, useAuth } from "../../frontend/src/context/AuthContext";
import "./styles.css";
import RequireAdmin from "./components/RequireAdmin";
import PlayerManager from "./pages/PlayerManager";
import TeamManager from "./pages/TeamManager";
import ScorecardPrintPage from "./pages/ScorecardPrintPage";
import MessageManagerPage from "./pages/MessageManagerPage";
import SubAssignmentManagerPage from "./pages/SubAssignmentManagerPage";
import AdminEnterScoresPage from "./pages/AdminEnterScoresPage";
import ScheduleHighlightsPage from "./pages/ScheduleHighlightsPage";
import AdminEnterPointsPage from "./pages/AdminEnterPointsPage";
import StandingsPage from "./pages/StandingsPage";
import AdminCalculateHandicapPage from "./pages/AdminCalculateHandicapPage";
import ContestEntryPage from "./pages/ContestEntryPage";
import SigninSheetPage from "./pages/SigninSheetPage";


const AppContent = () => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="app-container">
      <Navbar onMenuClick={() => setSidebarOpen(true)} />
      <div className="main-content">
        {user && <Sidebar show={sidebarOpen} handleClose={() => setSidebarOpen(false)} />}

        <Routes>
          <Route path="/" element={!user ? <Home /> : <Navigate to="/dashboard" />} />
          <Route path="/login" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/dashboard" element={user ? <Dashboard /> : <Navigate to="/" />} />
          <Route
  path="/player-management"
  element={
    <RequireLeagueAdmin>
      <PlayerManager />
    </RequireLeagueAdmin>
  }
/>
          <Route
                path="/admin-reset-password"
                element={
                  <RequireAdmin>
                    <AdminResetPassword />
                  </RequireAdmin>
                }
              />
          <Route path="/schedule" element={<ScheduleGrid leagueId={user?.leagueid} />} />
          <Route path="/generate-schedule" element={<AdminGenerateSchedule />} />
          <Route
  path="/schedule-manager"
  element={
    <RequireLeagueAdmin>
      <ScheduleManager />
    </RequireLeagueAdmin>
  }
/>
<Route
  path="/player-management"
  element={
    <RequireLeagueAdmin>
      <PlayerManager />
    </RequireLeagueAdmin>
  }
/>
<Route
  path="/team-management"
  element={
    <RequireLeagueAdmin>
      <TeamManager />
    </RequireLeagueAdmin>
  }
/>
<Route path="/handicap-generator" element={
  <RequireLeagueAdmin>
    <HandicapGenerator />
  </RequireLeagueAdmin>
}
/>

<Route
  path="/scorecards"
  element={
    <RequireLeagueAdmin>
      <ScorecardPrintPage  />
    </RequireLeagueAdmin>
  }
/>
<Route 
  path="/message-manager"   // <-- fix here
  element={
    <RequireLeagueAdmin>
      <MessageManagerPage />
    </RequireLeagueAdmin>
  }
/>
<Route 
  path="/sub-assignment-manager" 
  element={
    <RequireLeagueAdmin>
      <SubAssignmentManagerPage />
    </RequireLeagueAdmin>
  } 
/>

<Route 
  path="/admin-enter-scores" 
  element={
    <RequireLeagueAdmin>
      <AdminEnterScoresPage />
    </RequireLeagueAdmin>
  } 
/>

<Route 
  path="/schedule-highlights" 
  element={
    <RequireLeagueAdmin>
      <ScheduleHighlightsPage />
    </RequireLeagueAdmin>
  } 
/>
<Route path="/admin/enter-points" element={<RequireLeagueAdmin><AdminEnterPointsPage /></RequireLeagueAdmin>} />

<Route path="/standings" element={<StandingsPage />} />

<Route path="/calculate-handicaps" element={<RequireLeagueAdmin><AdminCalculateHandicapPage /></RequireLeagueAdmin>} />
<Route path="/contest-entry" element={<RequireLeagueAdmin><ContestEntryPage /></RequireLeagueAdmin>} />
<Route path="/signin-sheet" element={<RequireLeagueAdmin><SigninSheetPage /></RequireLeagueAdmin>} />
	</Routes>
      </div>
      <Footer />
    </div>
  );
};

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppContent />
      </Router>
    </AuthProvider>
  );
}

export default App;
